export default {
  layout: {
    backToHome: 'ホームに戻る',
    legalDocuments: '法務文書',
    product: '製品',
    developers: '開発者',
    company: '会社',
    legal: '法務',
  },
  nav: {
    markets: 'マーケット',
    aiAgents: 'AI エージェント',
    vaults: 'ボールト',
    leaderboard: 'ランキング',
    fees: '手数料',
    apiReference: 'API リファレンス',
    sdks: 'SDK',
    about: 'ZhiSu について',
    careers: '採用情報',
    contact: 'お問い合わせ',
    press: 'プレス・メディア',
    brand: 'ブランドガイドライン',
    terms: '利用規約',
    privacy: 'プライバシーポリシー',
    cookies: 'Cookie ポリシー',
    aml: 'AML ポリシー',
    risk: 'リスク開示',
    agreement: 'ユーザー契約',
    skills: 'スキル',
  },
  table: {
    pair: 'ペア',
    price: '価格',
    change24h: '24h 変動',
    volume24h: '24h 取引高',
    funding: '資金調達率',
    high24h: '24h 高値',
    low24h: '24h 安値',
    rank: '順位',
    trader: 'トレーダー',
    pnl30d: '30日損益',
    winRate: '勝率',
    method: 'メソッド',
    endpoint: 'エンドポイント',
    description: '説明',
    auth: '認証',
    required: '必須',
    none: '不要',
    trades: '取引回数',
    volume: '取引量',
    followers: 'フォロワー',
  },
  common: {
    lastUpdated: '最終更新日',
  },
  markets: {
    title: 'マーケット',
    subtitle: '50以上の暗号通貨ペアで永久先物を取引、最大50倍レバレッジ',
  },
  aiAgents: {
    title: 'AI エージェント',
    subtitle: '機械学習戦略を搭載した自律型AI取引エージェントを展開',
    pnl30d: '30日損益',
    winRate: '勝率',
    trades24h: '24h 取引回数',
    risk: 'リスク',
    avgHold: '平均保有時間',
  },
  vaults: {
    title: 'ボールト',
    subtitle: '組み込みリスク管理機能付き自動収益戦略ボールト',
    tvl: '預入総額',
    apy: '年間収益率',
    depositors: '預入者数',
    minDeposit: '最低預入額',
    riskLevel: 'リスクレベル',
    low: '低',
    medium: '中',
    high: '高',
  },
  leaderboard: {
    title: 'ランキング',
    subtitle: '30日損益でランキングしたトップトレーダー',
    allTime: '全期間',
    weekly: '週間',
  },
  fees: {
    title: '手数料',
    subtitle: 'すべてのトレーダーに対して透明で競争力のある手数料体系',
    tier: 'ティア',
    maker: 'メーカー',
    taker: 'テイカー',
    volume30d: '30日取引高',
    holderRequirement: 'HOLDER 保有要件',
    fundingRate: '資金調達率',
    fundingLong: 'ポジティブ時はロングがショートに支払う',
    fundingShort: 'ネガティブ時はショートがロングに支払う',
    withdrawalFees: '出金手数料',
    asset: '資産',
    networkFee: 'ネットワーク手数料',
    minWithdrawal: '最低出金額',
    perpetualTrading: 'パーペチュアル取引',
    interval: '間隔',
    settlement: '決済',
    maxRate: '最大レート',
  },
  apiReference: {
    title: 'API リファレンス',
    subtitle: '市場データ、取引、アカウント管理の完全REST APIドキュメント',
    baseUrl: 'ベースURL',
    authentication: '認証',
    authDesc: '公開エンドポイントは認証不要です。認証が必要なエンドポイントはX-API-KeyヘッダーにAPIキーを渡す必要があります。',
    rateLimits: 'レート制限',
    public: '公開',
    authenticated: '認証済み',
    websocket: 'WebSocket',
    epMarkets: '利用可能な全取引市場を一覧表示',
    epTicker: '特定市場の24時間ティッカーデータを取得',
    epOrderbook: '特定市場のオーダーブック深度を取得',
    epTrades: '特定市場の最近の取引を取得',
    epAccount: 'アカウント残高とポジションを取得',
    epOrders: '新規注文を作成',
    epCancelOrder: '既存注文をキャンセル',
    epOrdersList: '有効注文を一覧表示',
    epFills: '履歴約定を取得',
    epFundingRates: '全市場の現在の資金調達率を取得',
  },
  sdks: {
    title: 'SDK',
    subtitle: 'Python、TypeScript、Rust、Go の公式SDK',
    install: 'インストール',
    documentation: 'ドキュメント',
    pythonDesc: 'REST API と WebSocket ストリーミングのためのフル機能 Python クライアント。async/await、型ヒント、自動再接続をサポート。',
    tsDesc: '完全な型安全性、組み込みリトライロジック、ブラウザ/Node.js 互換性を備えたモダンな TypeScript/JavaScript クライアント。',
    rustDesc: '低レイテンシー取引ボットと定量的戦略向けに最適化された高性能 Rust クライアント。',
    goDesc: '並行 WebSocket サポートと効率的なメモリ管理を備えた軽量 Go クライアント。高頻度アプリケーション向け。',
  },
  about: {
    title: 'ZhiSu について',
    subtitle: '分散型デリバティブ取引の未来を構築する',
    ourValues: '私たちの価値観',
    leadershipTeam: 'リーダーシップチーム',
    backedBy: '出資者',
    decentralization: '分散化',
    decentralizationDesc: '金融市場が仲介者なしで機能する世界を信じています。ZhiSu上のすべての取引はオンチェーンで決済され、ユーザーは常に資産の完全な管理権を持ちます。',
    innovation: '革新',
    innovationDesc: 'DeFiの可能性の限界を押し広げています。AI駆動の取引エージェントからクロスチェーン流動性アグリゲーションまで、次世代金融のインフラを構築しています。',
    transparency: '透明性',
    transparencyDesc: 'すべてのプロトコル運営、手数料構造、ガバナンス決定は公開され監査可能です。スマートコントラクトは公開検証され、ロードマップはコミュニティと共有されています。',
    security: '安全性',
    securityDesc: '安全性は後付けではありません。コードは複数の独立した監査を受け、ユーザーの資金の安全を確保するための包括的なバグ報奨金プログラムを運営しています。',
    founded: '2024年に設立されたZhiSuは、最先端のブロックチェーンインフラ上に構築された次世代分散型デリバティブ取引所です。',
    volume: '累積取引高28億ドル以上、そして成長を続けるAI駆動取引エージェントのエコシステムを持ち、ZhiSuはDeFi分野で最も信頼されているプラットフォームの一つとなりました。',
    teamDesc: '私たちのチームは、一流の定量的ヘッジファンド、伝統的金融機関、トップブロックチェーンプロトコルからの専門知識を結集しています。',
    totalVolume: '累積取引高',
    activeTraders: 'アクティブトレーダー',
    markets: 'マーケット数',
    countries: '対応国数',
    ceo: '最高経営責任者',
    cto: '最高技術責任者',
    headProduct: 'プロダクト責任者',
    headAI: 'AI研究責任者',
    clo: '最高法務責任者',
    headEng: 'エンジニアリング責任者',
  },
  careers: {
    title: '採用情報',
    subtitle: 'AIネイティブ取引インフラを構築するチームに参加しよう',
    openPositions: '募集中の職種',
    allDepartments: 'すべての部門',
    engineering: 'エンジニアリング',
    product: 'プロダクト',
    design: 'デザイン',
    marketing: 'マーケティング',
    operations: 'オペレーション',
    legal: '法務',
    location: '勤務地',
    type: '雇用形態',
    applyNow: '応募する',
    benefits: 'ZhiSuで働く理由',
    benefit1Title: '競争力のある報酬',
    benefit1Desc: '市場平均を上回る給与、トークン配分、業績賞与。',
    benefit2Title: 'リモートファースト',
    benefit2Desc: 'どこからでも働けます。私たちはグローバルに分散したチームです。',
    benefit3Title: '最先端技術',
    benefit3Desc: 'AI、ブロックチェーン、分散システムの最新技術で構築します。',
    benefit4Title: '成長機会',
    benefit4Desc: '急速に成長する業界でキャリアの高速進展を実現。',
  },
  contact: {
    title: 'お問い合わせ',
    subtitle: '私たちのチームに連絡する',
    generalInquiries: '一般のお問い合わせ',
    support: 'サポート',
    press: 'プレス',
    partnerships: 'パートナーシップ',
    sendMessage: 'メッセージを送信',
    name: 'お名前',
    email: 'メールアドレス',
    subject: '件名',
    message: 'メッセージ',
    followUs: 'フォローする',
    response: '通常24時間以内に返信いたします。',
  },
  press: {
    title: 'プレス・メディア',
    subtitle: 'ZhiSu の最新ニュースとお知らせ',
    mediaContact: 'メディア連絡先',
    pressEmail: 'press@zhisu.trade',
    readMore: '続きを読む',
  },
  brand: {
    title: 'ブランドガイドライン',
    subtitle: '公式ブランドアセットと使用ガイドライン',
    logoUsage: 'ロゴの使用',
    colorPalette: 'カラーパレット',
    typography: 'タイポグラフィ',
    do: 'OK',
    dont: 'NG',
    primary: 'プライマリー',
    secondary: 'セカンダリー',
    background: '背景色',
    accent: 'アクセント',
    headingFont: '見出しフォント',
    bodyFont: '本文フォント',
    monoFont: '等幅フォント',
    logoRules1: '十分なコントラストを確保した暗色または明色の背景上でロゴを使用してください。',
    logoRules2: 'ロゴの周囲に、Vマークの高さに等しいクリアランスを確保してください。',
    logoRules3: '異なる背景に応じて提供されたカラーバリエーションを使用してください。',
  },
  terms: {
    title: '利用規約',
    s1: '1. 利用規約の同意',
    s2: '2. 資格',
    s3: '3. サービスの説明',
    s4: '4. アカウント登録とセキュリティ',
    s5: '5. 取引規則とリスク',
    s6: '6. 手数料と料金',
    s7: '7. 禁止活動',
    s8: '8. 知的財産権',
    s9: '9. 保証の免責',
    s10: '10. 責任の制限',
    s11: '11. 補償',
    s12: '12. 準拠法と紛争解決',
    s13: '13. 改訂',
    s14: '14. 連絡先',
  },
  privacy: {
    title: 'プライバシーポリシー',
    s1: '1. はじめに',
    s2: '2. 収集する情報',
    s3: '3. 情報の利用目的',
    s4: '4. 処理の法的根拠',
    s5: '5. 情報の共有と開示',
    s6: '6. データセキュリティ',
    s7: '7. データの保持',
    s8: '8. お客様の権利',
    s9: '9. 国際データ転送',
    s10: '10. 子供のプライバシー',
    s11: '11. ポリシーの変更',
    s12: '12. お問い合わせ',
  },
  cookies: {
    title: 'Cookie ポリシー',
    s1: '1. Cookie とは',
    s2: '2. Cookie の使用目的',
    s3: '3. 使用する Cookie の種類',
    s4: '4. 第三者 Cookie',
    s5: '5. Cookie 設定の管理',
    s6: '6. ウェビーコンと類似技術',
    s7: '7. 追跡拒否シグナル',
    s8: '8. ポリシーの変更',
    s9: '9. お問い合わせ',
  },
  aml: {
    title: 'AML ポリシー',
    s1: '1. 政策声明',
    s2: '2. 規制枠組み',
    s3: '3. 顧客デューデリジェンス（CDD）',
    s4: '4. 継続的監視',
    s5: '5. 禁止活動',
    s6: '6. 制裁コンプライアンス',
    s7: '7. 疑わしい活動の報告',
    s8: '8. 記録の保存',
    s9: '9. スタッフ教育',
    s10: '10. 独立監査',
    s11: '11. お問い合わせ',
  },
  risk: {
    title: 'リスク開示',
    s1: '1. 重要な通知',
    s2: '2. 財務アドバイスではありません',
    s3: '3. 市場リスク',
    s4: '4. レバレッジと証拠金リスク',
    s5: '5. スマートコントラクトと技術リスク',
    s6: '6. AI エージェントと自動取引リスク',
    s7: '7. カストディとウォレットリスク',
    s8: '8. 規制とコンプライアンスリスク',
    s9: '9. サイバーセキュリティリスク',
    s10: '10. 全額損失リスク',
    s11: '11. プラットフォーム可用性の保証なし',
    s12: '12. 確認',
    s13: '13. お問い合わせ',
  },
  agreement: {
    title: 'ユーザー契約',
    s1: '1. 契約の概要',
    s2: '2. 定義',
    s3: '3. アカウントとウォレット接続',
    s4: '4. 取引規則',
    s5: '5. 手数料と支払い',
    s6: '6. AI エージェントと自動化サービス',
    s7: '7. API の使用',
    s8: '8. 表明と保証',
    s9: '9. 終了',
    s10: '10. 紛争解決',
    s11: '11. 変更',
    s12: '12. 完全合意',
    s13: '13. お問い合わせ',
  },
  skills: {
    title: 'スキル',
    subtitle: 'コミュニティが構築したAIエージェントのスキルを発見してインストール',
    searchPlaceholder: '何をお探しですか？',
    install: 'インストール',
    installNow: 'インストール',
    categories: {
      all: 'すべて',
      defi: 'DeFi & 取引',
      social: 'ソーシャル & メッセージ',
      tools: '分析 & ツール',
      other: 'その他',
    },
    stats: {
      tools: 'ツール',
      users: 'ユーザー',
      downloads: 'ダウンロード',
      rating: '平均評価',
    },
    featuredSkills: 'おすすめスキル',
    trendingNow: 'トレンド',
    viewAll: 'すべて表示',
    allSkills: 'すべてのスキル',
    searchResults: '検索結果',
    noResults: '条件に一致するスキルが見つかりませんでした。',
    builtByCommunity: 'コミュニティによる構築',
    equip: '装備',
    unleash: '解放',
    toolsReady: '何千もの開発者が構築したツールを、検索一つで利用可能に。',
    installCommand: 'インストールコマンド',
    copied: 'コピーしました！',
    copy: 'コピー',
    about: '概要',
    usageExample: '使用例',
    info: '情報',
    related: '関連スキル',
    backToSkills: 'スキル一覧に戻る',
    notFound: 'スキルが見つかりません',
    notFoundDesc: 'お探しのスキルは存在しません。',
  },
};